import React from 'react';
import { CHANGELOG } from '../../data/changelog';

/** Small, plain notes about what changed in the portal itself. */
export function WhatsNewTile() {
  return <section aria-labelledby="whats-new" className="flex flex-col rounded-card border border-rule bg-card" data-id="element-128" data-mp="28jjxl8204qxi">
      <h2 id="whats-new" className="border-b border-rule px-5 py-4 text-heading font-semibold text-ink" data-id="element-129" data-mp="2iju9mpcavsb3">
        New in the portal
      </h2>
      <ul className="flex flex-col divide-y divide-rule" data-id="element-130" data-mp="2wd236mjxyxvf">
        {CHANGELOG.map(entry => <li key={entry.title} className="flex flex-col gap-1 px-5 py-4" data-id="element-131" data-mp="2rdyyx4bscvoi">
            <div className="flex flex-wrap items-baseline justify-between gap-x-3" data-id="element-132" data-mp="367tz7lxvlco3">
              <h3 className="text-body font-medium text-ink" data-id="element-133" data-mp="31b3ozf8r5bal">{entry.title}</h3>
              <span className="text-small text-ink-muted" data-id="element-134" data-mp="1bum3ls22sx1e">{entry.date}</span>
            </div>
            <p className="text-small text-ink-muted" data-id="element-135" data-mp="16wkk560qmvpe">{entry.body}</p>
          </li>)}
      </ul>
    </section>;
}